import { MutationOptions } from "@tanstack/react-query";
import { useBaseMutation } from "../baseMutation";
import { HttpRequest, RestError } from "@maven-rest/common/HttpRequest";
import { DownloadFolderFileRequest, DownloadFolderFileResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useDownloadFolderFileMutation(
  options?: MutationOptions<DownloadFolderFileResponse, RestError<DownloadFolderFileResponse>, DownloadFolderFileRequest, unknown>
) {
  return useBaseMutation({
    mutationFn: async ({ fileId }: DownloadFolderFileRequest) => {
      const resp = await HttpRequest.request<DownloadFolderFileResponse>(
        process.env.REACT_APP_DOCS_BE_URL || "",
        ...FolderFileUrl.downloadFolderFile(fileId),
        { fileId },
        {}
      );

      return resp.data;
    },
    ...options,
  });
}
